import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

export interface FooterStyles {
    page?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {};
const styles = footerStyles;

const Footer = ({ id }: PageProps) => {
    React.useEffect(() => {
        const updateCanonicalAndUrl = () => {
            const url = new URL(window.location.href);

            // Remove page=1
            if (url.searchParams.get("page") === "1") {
                url.searchParams.delete("page");

                const cleanUrl = url.pathname + (url.searchParams.toString() ? `?${url.searchParams.toString()}` : "");

                // Update browser URL
                window.history.replaceState({}, "", cleanUrl);
            }

            // Final canonical URL
            const canonicalUrl = window.location.origin + window.location.pathname + window.location.search;

            let canonicalLink = document.querySelector("link[rel='canonical']");

            if (!canonicalLink) {
                canonicalLink = document.createElement("link");
                canonicalLink.setAttribute("rel", "canonical");
                document.head.appendChild(canonicalLink);
            }

            canonicalLink.setAttribute("href", canonicalUrl);
        };

        // Initial run
        updateCanonicalAndUrl();

        // Listen for browser navigation
        window.addEventListener("popstate", updateCanonicalAndUrl);

        // Monkey patch pushState
        const originalPushState = window.history.pushState;
        window.history.pushState = function (...args) {
            originalPushState.apply(this, args);
            updateCanonicalAndUrl();
        };

        // Monkey patch replaceState
        const originalReplaceState = window.history.replaceState;
        window.history.replaceState = function (...args) {
            originalReplaceState.apply(this, args);
            updateCanonicalAndUrl();
        };

        return () => {
            window.removeEventListener("popstate", updateCanonicalAndUrl);

            window.history.pushState = originalPushState;
            window.history.replaceState = originalReplaceState;
        };
    }, []);

    return (
        <Page as="footer" isFooter={true} {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
